export const DECIMAL_PLACES = 2;
